require.ensure(["./a"], function(require) {
	require("./a").should.be.eql("a");
})


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/duplicate.js
 ** module id = 2
 ** module chunks = 1 6
 **/